import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { ServiceProviderResolver } from '../resolvers';
import { ServiceProviderService } from '../services';

@Injectable()
export class ServiceProviderGuard implements CanActivate {
  constructor(
    private router: Router,
    private resolver: ServiceProviderResolver,
    private serviceProviderSvc: ServiceProviderService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    this.resolver.serviceProvider = null;

    const serviceProviderId = route.params['serviceProviderId'];
    if (!serviceProviderId) return false;

    // Runs alongside StaffRoleGuard; returning false (not throwing) on a 403 lets its redirect win.
    const serviceProvider = await this.serviceProviderSvc.getOne(serviceProviderId).catch(() => undefined);
    if (serviceProvider === undefined) return false;
    if (serviceProvider === null) return this.router.createUrlTree(['/404']);

    this.resolver.serviceProvider = serviceProvider;
    return true;
  }
}
